import * as types from './types';

export const state = {
  list: [],
};

const find = (state, data, callback) => state.list.map(option => {
  if (option.id === data.id) {
    callback(option);
  }

  return option;
});

export const mutations = {
  [types.OPTION_ADD](state, { data }) {
    const otherOptionIndex = state.list.findIndex(option => option.other);

    state.list.push(data);

    if (otherOptionIndex > -1) {
      state.list.push(state.list.splice(otherOptionIndex, 1)[0]);
    }
  },
  [types.OPTION_REMOVE](state, index) {
    state.list.splice(index, 1);
  },
  [types.OPTION_UPDATE_LABEL](state, data) {
    find(state, data, (option) => {
      option.label = data.label;
    });
  },
  [types.OPTION_SET_ACTIVE](state, options) {
    state.list = options;
  },
  [types.OPTION_RESET_ACTIVE](state) {
    state.list = [];
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/option/mutations.js
 **/